module.exports = __webpack_public_path__ + "img/gobierno.49c09a5f.jpeg";